
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesPreview from './components/ServicesPreview';
import TrustIndicators from './components/TrustIndicators';
import CTASection from './components/CTASection';

const HomePage = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div className="bg-ivory min-h-screen">
      <Navigation />
      
      <main>
        <HeroSection />
        <TrustIndicators />
        
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <ServicesPreview />
        </motion.div>
        
        <CTASection />
      </main>
      
      <Footer />
    </div>
  );
};

export default HomePage;
